module.exports = __webpack_public_path__ + "static/cf-bold-italic-933af937ae0853288acad86ebf8bd3f3.eot";